import { useMemo } from "react";

import { TIER_PLANS_LABELS } from "constants/tiers";
import useTypedContext from "hooks/useTypedContext";

import { BillingContext } from "../Context";
import BillingMarketingTile from "../MarketingTile";
import { TALK_TO_SALES_LINK } from "../constants";

const BillingCancelSubscriptionAnnouncement = () => {
  const { tier } = useTypedContext(BillingContext);

  const data = useMemo(
    () => ({
      title: "Choose plan",
      subtitle: "We're here to help",
      description: `If the ${TIER_PLANS_LABELS[tier]} plan didn't meet your expectations, we can help. Schedule a call with our team to discuss your goals and let us help you choose the plan tailored to your needs.`,
      ctaText: "Talk to sales",
      ctaHref: TALK_TO_SALES_LINK,
    }),
    [tier]
  );

  return <BillingMarketingTile data={data} />;
};

export default BillingCancelSubscriptionAnnouncement;
